import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function ProblemSection() {
  const {
    t
  } = useTranslation();
  return <section className="py-20 bg-white relative" data-id="element-368">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-369">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-370">
          <h2 className="font-serif text-4xl md:text-5xl text-gray-900 mb-8" data-id="element-371">
            {t.problem.heading}
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 font-medium" data-id="element-372">
            {t.problem.main}
          </p>
          <p className="text-lg text-gray-500 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-373">
            {t.problem.body}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative bg-cream-50 rounded-2xl p-8 md:p-12 shadow-sm border border-lavender-100 max-w-3xl mx-auto" data-id="element-374">
          <Quote className="absolute top-6 left-6 w-8 h-8 text-lavender-200 rotate-180" data-id="element-375" />
          <Quote className="absolute bottom-6 right-6 w-8 h-8 text-lavender-200" data-id="element-376" />
          <p className="font-serif italic text-2xl md:text-3xl text-gray-800 relative z-10" data-id="element-377">
            {t.problem.quote1}
            <br data-id="element-378" />
            <span className="text-lavender-600 font-semibold mt-4 block" data-id="element-379">
              {t.problem.quote2}
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}